import React, { useEffect, useState } from "react";
import ProfileBar from "./components/ProfileBar";
import PageTitle from "./components/PageTitle";
import { conf } from "./const";
import { useParams } from "react-router-dom";
import { fetchData } from "./js/main";

export default function Bill(props) {
  const [otp, setOTP] = useState();
  const params = useParams();
  useEffect(() => {
    (async () => {
      const otp = await fetchData(
        "put",
        "/v3/bill/file/" + params.bill_id + "/otp"
      );
      setOTP(otp);
    })();
  }, [params]);

  const styles = {
    height: "80vh",
    width: "100%",
  };
  return (
    <div className="content">
      <ProfileBar profile={props.profile} />
      <PageTitle page={props.page} />
      {otp && (
        <object
          aria-label="pdf"
          data={
            conf.endpoint.epayment + "/v3/bill/file/" + otp.otp + "?#view=FitV"
          }
          type="application/pdf"
          style={styles}
        ></object>
      )}
    </div>
  );
}
